
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class SalaryPackageGrid extends _Ext.GridBase<SalaryPackageRow, any> {
        protected getColumnsKey() { return 'HR.SalaryPackage'; }
        protected getDialogType() { return SalaryPackageDialog; }
        protected getIdProperty() { return SalaryPackageRow.idProperty; }
        protected getInsertPermission() { return SalaryPackageRow.insertPermission; }
        protected getLocalTextPrefix() { return SalaryPackageRow.localTextPrefix; }
        protected getService() { return SalaryPackageService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}